import { createAction, props } from '@ngrx/store'
import { InfoboothsEntity } from './infobooths.models'
import { Update } from '@ngrx/entity'
import { HttpErrorResponse } from '@angular/common/http'

export const loadInfobooths = createAction('[Infobooths Page] Init')

export const loadInfoboothsSuccess = createAction(
  '[Infobooths/API] Load Infobooths Success',
  props<{ infobooths: InfoboothsEntity[] }>(),
)

export const loadInfoboothsFailure = createAction(
  '[Infobooths/API] Load Infobooths Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const selectInfobooth = createAction('[Infobooth/Page] Select Infobooth', props<{ uuid: string }>())

export const updateSelectedInfobooth = createAction(
  '[Infobooth/Page] Update Selected Infobooth',
  props<{ infobooth: Partial<InfoboothsEntity> }>(),
)

export const updateSelectedInfoboothSuccess = createAction(
  '[Infobooth/Page] Update Selected Infobooth Success',
  props<{ update: Update<InfoboothsEntity> }>(),
)

export const updateSelectedInfoboothFailure = createAction(
  '[Infobooth/Page] Update Selected Infobooth Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const clearSelectedInfobooth = createAction('[Infobooth/Page] Clear Selected Infobooth')

export const openCreateInfoboothDialog = createAction('[Infobooth/Page] Open create infobooth dialog')

export const createInfobooth = createAction(
  '[Infobooth/Page] Create Infobooth',
  props<{ infobooth: Partial<InfoboothsEntity> }>(),
)

export const createInfoboothSuccess = createAction(
  '[Infobooth/Page] Create Infobooth Success',
  props<{ infobooth: InfoboothsEntity }>(),
)

export const createInfoboothFailure = createAction(
  '[Infobooth/Page] Create Infobooth Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const deleteInfobooth = createAction('[Infobooth/Page] Delete Infobooth', props<{ uuid: string }>())

export const deleteInfoboothSuccess = createAction(
  '[Infobooth/Page] Delete Infobooth Success',
  props<{ uuid: string }>(),
)

export const deleteInfoboothFailure = createAction(
  '[Infobooth/Page] Delete Infobooth Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const clearInfobooths = createAction('[Infobooths/Page] Clear Infobooths')
